<template>
  <div id="question" class="d-flex flex-fill">
    <div class="d-flex flex-column w-50 border-end-dashed p-4 gap-3 overflow-auto">
      <!-- begin::question -->
      <RenderQuestion :question="question"></RenderQuestion>
      <!-- end::question -->

      <!-- begin::matetials -->
      <FileList :title="$t('materials')" v-if="question.materials && question.materials.length > 0"
                :files="question.materials"></FileList>
      <!-- end::matetials -->
    </div>
    <div class="d-flex flex-column w-50 border-end-dashed p-4 gap-3 overflow-auto">
      <!-- answer input -->
      <div class="d-flex flex-column w-100 align-items-center gap-3">
        <h5 class="text-primary text-bold m-0 fs-5 text-center text-uppercase">{{
            $t('choose_one_correct_answer')
          }}</h5>
        <div class="d-flex flex-column w-75 align-items-center gap-3 pb-3">
          <button type="button" class="answer-item"
                  :class="{ active: parseInt(answer.answer) == qanswer.id, correct: parseInt(answer.answer) == qanswer.id && answer?.is_correct == 1 && ['completed', 'over_due'].includes(assignment.state_submissions.status) && show_answer == 1, 'in-correct': parseInt(answer.answer) == qanswer.id && answer?.is_correct == 0 && ['completed', 'over_due'].includes(assignment.state_submissions.status) && show_answer == 1} "
                  v-for="(qanswer, index) in question.answers" @click="selectAnswer(qanswer.id)"
                  :disabled="['completed', 'submitted', 'over_due'].includes(assignment.state_submissions.status)">
            <span>{{ toAlphabet(index) }}</span>
            <template v-if="question.answer_type === 'text'">
              {{ qanswer.content }}
            </template>
            <template v-else>
              <div class="flex-fill ratio ratio-16x9 d-flex justify-content-center align-items-center">
                <img class="answer-img" :src="qanswer.answer_url" :alt="qanswer.answer_url">
              </div>
            </template>
          </button>
        </div>
      </div>
      <!-- end answer input -->

      <template v-if="assignment.answer_keys && assignment.answer_keys.length > 0">
        <!-- begin::explanation -->
        <div class="d-flex flex-column w-100 align-items-center gap-3" v-if="question.explanation">
          <h5 class="text-primary text-bold m-0 fs-5 text-center text-uppercase">{{ $t('Explanation') }}</h5>
          <p class="question-text" v-html="question.explanation"></p>
        </div>
        <!-- end::explanation -->

        <!-- begin::Answer key -->
        <FileList :title="$t('answer_key')" :files="assignment.answer_keys"></FileList>
        <!-- end::Answer key -->
      </template>

    </div>
  </div>
</template>

<script>
import FileList from './components/FileList';
import RenderQuestion from './components/RenderQuestion';

export default {
  name: "QuestionMultipleChoice",
  components: {FileList, RenderQuestion},
  props: ['question', 'assignment', 'show_answer'],
  data() {

    return {
      answer: Array.isArray(this.question.submissions.answer) ? this.question.submissions.answer[0] : {
        answer: undefined,
        is_correct: 0
      },
      errors: {
        file: undefined,
      },
    }
  },
  created() {
  },

  methods: {
    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    },

    handleFileExtension(filename) {
      const fileExtension = filename.split('.').pop().toLowerCase();
      return fileExtension
    },

    saveFile(url) {
      var filename = url.substring(url.lastIndexOf("/") + 1).split("?")[0];
      var xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function () {
        var a = document.createElement('a');
        a.href = window.URL.createObjectURL(xhr.response);
        a.download = filename;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      };
      xhr.open('GET', url);
      xhr.send();
    },

    toAlphabet(num) {
      const alpha = Array.from(Array(26)).map((e, i) => i + 65);
      const alphabet = alpha.map((x) => String.fromCharCode(x));
      return alphabet[num];
    },

    selectAnswer(answer_id) {
      const answer_id_str = String(answer_id);
      this.answer = {answer: answer_id_str, is_correct: 0};
      this.$emit('answer', this.question.id, [this.answer])
    },
  }
}
</script>

<style scoped>
.border-end-dashed {
  border-right: 1px dashed #EAEAEA;
}

.question-text {
  white-space: pre-line;
}

.answer-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid;
  color: inherit;
  box-shadow: 0px 8px #EAEAEA;
  border-color: #EAEAEA;
  border-radius: 8px;
  background: #FFFFFF;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
  transition: all .3s ease-in-out;
}

.answer-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.answer-item span {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  background: #DDDDDD;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  transition: all .3s ease-in-out;
}

.answer-item.active,
.answer-item:not(:disabled):hover {
  background: #DBEAFE;
  border-color: #0EA5E9;
  box-shadow: 0px 8px #0EA5E9;
}

.answer-item.active span,
.answer-item:not(:disabled):hover span {
  color: #FFFFFF;
  background: #0EA5E9;
}

.answer-item.correct {
  background: #E8FFD8;
  border-color: #58CC02;
  box-shadow: 0px 8px #58CC02;
}

.answer-item.correct span {
  color: #FFFFFF;
  background: #58CC02;
}

.answer-item.in-correct {
  background: #FFD6DB;
  border-color: #FF3D54;
  box-shadow: 0px 8px #FF3D54;
}

.answer-item.in-correct span {
  color: #FFFFFF;
  background: #FF3D54;
}
</style>